























import { Component, Prop, Vue } from 'vue-property-decorator';
import DocIcon from '@/components/ui/icons/DocIcon.vue';

enum ButtonTheme {
  PRIMARY = 'primary',
  GHOST = 'ghost',
  OUTLINE = 'outline',
}

enum ButtonSize {
  SMALL = 'small', // 32px
  MEDIUM = 'medium', // 40px
  LARGE = 'large', // 48px
}

@Component({
  components: {
    DocIcon,
  },
})
export default class DocButton extends Vue {
  @Prop({ default: 'primary' }) theme!: ButtonTheme;
  @Prop({ default: 'small' }) size!: ButtonSize;
  @Prop({ default: '' }) href!: string;
  @Prop({ default: '' }) to!: [string, object];
  @Prop({ default: '' }) icon!: string;
  @Prop({ default: false }) isInvisible!: boolean;

  private hoverState = false;

  private get computedClass(): object {
    return {
      'doc-button_primary': this.theme === ButtonTheme.PRIMARY,
      'doc-button_ghost': this.theme === ButtonTheme.GHOST,
      'doc-button_outline': this.theme === ButtonTheme.OUTLINE,

      'doc-button_small': this.size === ButtonSize.SMALL,
      'doc-button_medium': this.size === ButtonSize.MEDIUM,
      'doc-button_large': this.size === ButtonSize.LARGE,

      'doc-button_with-icon': this.icon && this.$slots.default,
      'doc-button_icon-only': this.icon && !this.$slots.default,
    };
  }

  private get computedTag(): string {
    if (this.href) return 'a';
    if (this.to) return 'router-link';
    return 'button';
  }
}
